import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import styled from 'styled-components';
var Svg = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: currentColor;\n  width: 24px;\n  height: 24px;\n  display: inline-block;\n  font-size: 24px;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  flex-shrink: 0;\n  user-select: none;\n"])));
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
});
var Visibility = function Visibility(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    focusable: "false",
    role: "presentation"
  }, props), _ref);
};
export default Visibility;